<template>
  <div class="row">
    <div class="col-md-12 d-flex justify-content-between">
      <h1 class="h3 mb-3 text-gray-800">
        {{ $t("Relatórios do SCFV") }}
      </h1>

      <b-dropdown
        no-caret
        variant="primary"
        size="sm"
        v-b-tooltip.hover
        right
        title="Menu de Relatórios"
      >
        <template #button-content>
          Menu
          <i class="fas fa-bars"></i>
        </template>
        <b-dropdown-group id="dropdown-group-1" header="Relatórios do SCFV">
          <b-dropdown-item
            to="/dashboard/relatorios/scfv/grupos"
            :disabled="$route.name == 'relatorios_grupos_scfv'"
          >
            Todos os Grupos do SCFV
          </b-dropdown-item>
          <b-dropdown-item
            to="/dashboard/relatorios/scfv/inscritos"
            :disabled="$route.name == 'relatorios_inscritos_scfv'"
          >
            Inscritos e Situações Prioritárias do SCFV
          </b-dropdown-item>
          <b-dropdown-item
            to="/dashboard/relatorios/scfv/participantes/atividades"
            :disabled="$route.name == 'relatorios_participantes_atividades'"
          >
            Usuários com participações confirmadas em atividades
          </b-dropdown-item>
          <b-dropdown-item
            to="/dashboard/relatorios/scfv/home"
            :disabled="$route.name == 'graficos_scfv'"
          >
            Gráficos do SCFV
          </b-dropdown-item>
        </b-dropdown-group>
      </b-dropdown>
    </div>

    <div class="col-md-12">
      <load v-if="loading" />
      <router-view v-else />
    </div>
  </div>
</template>
<script>
export default {
  name: "ReportsScfv",
  metaInfo() {
    return {
      title: this.$i18n.t("Relatórios SCFV"),
    };
  },
  mounted() {},
  data() {
    return {
      loading: false,
    };
  },
  methods: {},
};
</script>
